export enum DOC_TYPES {
  SELFIE = 'SELFIE',
  IDENTITY_CARD_FRONT = 'IDENTITY_CARD_FRONT',
  IDENTITY_CARD_REAR = 'IDENTITY_CARD_REAR',
  DRIVER_LICENSE_FRONT = 'DRIVER_LICENSE_FRONT',
  DRIVER_LICENSE_REAR = 'DRIVER_LICENSE_REAR',
  COMPANY_STATUTE = 'COMPANY_STATUTE',
  DIRECTORS_ELECTION_MINUTE = 'DIRECTORS_ELECTION_MINUTE',
  DIGITAL_DOCUMENT = 'DIGITAL_DOCUMENT',
  SIGNATURE = 'SIGNATURE',
}
